export const imprintLink = {
  url: 'https://www.immomio.com/impressum/',
  name: 'general.imprint'
};

export const termsLink = {
  url: 'https://www.immomio.com/agb-mietinteressenten/',
  name: 'general.terms'
};

export const dataPrivacyLink = {
  url: 'https://www.immomio.com/datenschutz-mietinteressenten/',
  name: 'general.data_privacy'
};
export const accessibilityLink = {
  url: 'https://immomio-asset-store.s3.eu-central-1.amazonaws.com/250626_Interessentenportal_Barrierefreiheitserkla%CC%88rung.pdf',
  name: 'general.accessibility'
};

export const impressum_agb_links_config = {
  links: [termsLink, dataPrivacyLink, imprintLink, accessibilityLink]
};
